<template>
  <div class="cookie-notice-wrapper">
    <div class="cookie-modal-main cookie-modal-main-notice">
      <div class="cookie-modal-main-content">
        <div class="cookie-modal-container">
          <div class="cookie-top-content">
            <p class="cookie-top-content-body">
              <span v-html="t(
                'cookies.notice.main',
                { params: [{ shopname: eshopName, policyurl: policyUrl }] }
                )"
              ></span>
              <button
                class="cookie-top-content-accept-essentials-btn"
                data-action="consentToCookiesEssential"
                @click="postCookieSettingsEssentials"
              >
                <span data-action="consentToCookiesEssential">{{ t('cookies.accept_essentials') }}</span>
              </button>
            </p>
          </div>
          <div class="cookie-bottom-content">
            <button
              class="cookie-bottom-content-accept-btn"
              data-action="consentToCookiesAll"
              @click="postCookieSettingsAllGrantedAction"
            >
              <span data-action="consentToCookiesAll">{{ t('cookies.accept') }}</span>
            </button>
            <button class="cookie-bottom-content-settings-btn" @click="openSettings">{{ t('cookies.more') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CookieConsentNamesEnum } from '../../../../vue/cookies/store/cookiesModule'
import { setCookie } from '../../../js/es6/utilities/cookie-access'
import { mapActions } from 'vuex'

export default {
  name: 'CookieNotice',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions('cookies', [
      'openSettings',
      'setAllConsentValuesToGranted'
    ]),
    postCookieSettingsAll () {
      setCookie(
        CookieConsentNamesEnum.CONSENT_STATUS,
        true,
        365
      ).then(() => {
        this.$root.$emit('cookies-modal-close')
      })
    },
    postCookieSettingsEssentials () {
      Promise.all([
        setCookie(
          CookieConsentNamesEnum.CONSENT_STATUS,
          true,
          365
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_FUNCTIONALITY_STORAGE,
          true,
          365
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_AD_STORAGE,
          false,
          365
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_ANALYTICS_STORAGE,
          false,
          365
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_PERSONALIZATION_STORAGE,
          false,
          365
        )
      ]).then(() => {
        this.$root.$emit('cookies-modal-close')
      })
    },
    eshopName () {
      return this.t('hct.eshop.name')
    },
    policyUrl () {
      return this.t('hct.eshop.policy.url')
    },
    async postCookieSettingsAllGrantedAction () {
      await setCookie(
        CookieConsentNamesEnum.CONSENT_STATUS,
        true,
        365
      )
      await this.setAllConsentValuesToGranted()
      this.$root.$emit('cookies-modal-close')
    }
  }
}
</script>
